// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"e7e4a6ed","92":"bb05fad9","189":"d188509d","213":"98258333","246":"24fca0c4","324":"8807308f","375":"cf9c9735","430":"2b10bbec","478":"ad33496d","546":"2fedccaa"}[chunkId] + ".chunk.js";
};